export { default } from "./bookmark.js";
